import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { SharedModule } from 'src/app/shared.module';
import { BasicCardComponent } from './basic-card/basic-card.component';
import { CardParent } from './card-parent.component';
import { CardDirective } from './card.directive';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [CardDirective, BasicCardComponent, CardParent],
  exports: [CardParent],
})
export class CardsModule {
  public static forRoot(): ModuleWithProviders<CardsModule> {
    return {
      ngModule: CardsModule,
      providers: [CardDirective],
    };
  }
}
